import { defineCustomElement } from "vue";
import { Register } from "..";
import F360BannerFinanceiro from "./F360BannerFinanceiro.ce.vue";

const _register: Register = {
  register() {
    if (!customElements.get("vc-banner-financeiro")) {
      const CustomElement = defineCustomElement(F360BannerFinanceiro);
      customElements.define("vc-banner-financeiro", CustomElement);
    }
  }
};

export default _register;
